import React from 'react';
import './index.css';
import { render } from 'react-dom';
import ReactPixel from 'react-facebook-pixel';
import { App } from './App';
ReactPixel.init('1066197829912555');
ReactPixel.pageView();
render(<App data-id="element-212" />, document.getElementById('root'));